/* eslint-env browser */
import * as React from 'react'

import { extractArticleFullName } from '../../../../../../shared/services/gear-service'
import { replaceStorageByCdn } from '../../../../../../shared/services/media-helper'

const PropTypes = require('prop-types')

class GearItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { gear, productCategory } = this.props

    let imgUrl = replaceStorageByCdn(gear.mediaUrl_100 || gear.mediaUrl_300 || gear.mediaUrl_600 || gear.mediaUrl)
    if (!imgUrl && (gear.medias || []).length > 0) {
      imgUrl = gear.medias[0].url_100 || gear.medias[0].url_300 || gear.medias[0].url_600 || gear.medias[0].url
    }
    if (!imgUrl) {
      if (productCategory && productCategory.icon) {
        imgUrl = productCategory.icon.url_300 || productCategory.icon.url_100
      }
    }

    let fullName
    if (gear.isCustomProduct) {
      fullName = gear.name.toUpperCase()
    } else {
      fullName = extractArticleFullName({
        productName: gear.productName,
        modelName: gear.productModelName,
        articleName: gear.productArticleName,
      })
    }

    let { brandName, brandSeoName } = gear
    if (gear.brand) {
      if (!brandName) {
        brandName = gear.brand.name
      }
      if (!brandSeoName) {
        brandSeoName = gear.brand.seoName
      }
    }

    return (
      <div>
        {imgUrl && gear.productSeoName && (
          <a href={`/gear/products/${gear.productSeoName}?pa=${gear.productArticleSeoName}`}>
            <figure className="image is-3by1">
              <img src={imgUrl} className="has-object-fit-contain" alt={fullName} title={fullName} />
            </figure>
          </a>
        )}
        {imgUrl && !gear.productSeoName && (
          <figure className="image is-2by1">
            <img src={imgUrl} className="has-object-fit-contain" alt={fullName} title={fullName} />
          </figure>
        )}
        <div className="is-size-8">
          {brandSeoName && <a href={`/gear/brands/${brandSeoName}`}>{brandName}</a>}
          {!brandSeoName && gear.customBrandName && <span>{gear.customBrandName}</span>}
          {gear.productSeoName && (
            <a
              href={`/gear/products/${gear.productSeoName}?pa=${gear.productArticleSeoName}`}
              className="has-text-grey has-text-break-word"
            >
              {` ${fullName}`}
            </a>
          )}
          {!gear.productSeoName && <span>{` ${fullName}`}</span>}
        </div>
      </div>
    )
  }
}

GearItem.propTypes = {
  gear: PropTypes.object.isRequired,
  productCategory: PropTypes.object,
}

GearItem.defaultProps = {
  productCategory: null,
}

module.exports = GearItem
